/**
 * Created by Greg on 5/9/2016.
 * Works with demand objects of the form:

 Example:
 {   "id": "DemandsNet1",
     "desc": "Example demands for network 1",
     "demandList": [
         {"source": "H1", "target": "H2", "demand": 51.3},
         {"source": "H2", "target": "S3", "demand": 21.0}]
 }
 */
import jjv from 'jjv';
import * as demandSchema from './demandSchema.json';

/**
 * Demand validator checks for valid JSON, schema compliance, and
 * the for compatibility of the demands with the current network.
 *
 * @param demandString The JSON string of paths to validate
 * @returns object
 */
function demandCollectionValidate(demandString) {
    let demandObj = null,
        errors = null;
    try {
        demandObj = JSON.parse(demandString);
    } catch (e) {
        errors = "Invalid JSON string: " + e;
    }
    if (demandObj) {
        let env = jjv();
        env.checkRequired = true;
        errors = env.validate(demandSchema, demandObj);
    }
    return {errors: errors, demandObj: demandObj};
}

function demandValidate(demand, net) {
    let nodes = net.nodes;
    let srcNode = nodes.find(function (n) {
        return n.id === demand.source;
    });
    if (!srcNode) {
        return false;
    }
    let trgNode = nodes.find(function (n) {
        return n.id === demand.target;
    });
    if (!trgNode) {
        return false;
    }
    return true;
}


export {demandCollectionValidate, demandValidate};


// WEBPACK FOOTER //
// ./validation/demandValid.js